import React from "react";
import "../styles/aboutUs.css";
import { useLanguage } from "./Context/LanguageContext";
import translations from "./translations";

function AboutUs() {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <>
      <section className="about-us-section">
        <div className="container">
          <h2>{t.aboutUsTitle}</h2>
          <p>
            {t.aboutUsContent}
          </p>
        </div>
      </section>
      <section className="mission-vision-section">
        <div className="mission-box">
          <h2>{t.missionTitle}</h2>
          <p>
            {t.missionContent}
          </p>
        </div>
        <div className="vision-box">
          <h2>{t.visionTitle}</h2>
          <p>
            {t.visionContent}
          </p>
        </div>
      </section>
    </>
  );
}

export default AboutUs;
